export default import.meta.ROLLDOWN_FILE_URL_Fg907cfaBf941t5yTg6kag